<div class="flex column case-quick-filters-container">
  <div class="flex case-quick-filters">
    @for (option of options; track option) {
      <button
        payee-button
        class="case-quick-filter-item"
        width="auto"
        color="white"
        [isBorderButton]="true"
        [isRoundButton]="true"
        [class.selected]="option === (selectedOption$ | async)"
        (click)="selectOption(option)"
      >
        {{ "CASES_TABLE.CASE_QUICK_FILTERS." + option | translate }}
      </button>
    }
  </div>

  @if (showTodoSubTabs && (selectedOption$ | async) === "todo") {
    <div class="flex case-quick-filters case-todo-sub-filters">
      @for (option of todoSubTabOptions; track option) {
        <button
          payee-button
          class="case-quick-filter-item"
          width="shorter"
          color="white"
          [isBorderButton]="true"
          [isRoundButton]="true"
          [class.selected]="option === (selectedTodoSubTab$ | async)"
          (click)="selectTodoSubTab(option)"
        >
          {{ "CASES_TABLE.CASE_QUICK_FILTERS.todo_" + option.toLowerCase() | translate }}
        </button>
      }
    </div>
  }
</div>
